import React, { useState } from "react";

import { Input } from "./../../../Components/ui/input";

function ChangePassword() {
  const [passwordForm, setPasswordForm] = useState({
    verifyPassword: "",
  });

  const [errors, setErrors] = useState({
    verifyPassword: "",
  });

  // const validatePassword = (password) => {
  //   setValidations({
  //     hasLength: password.length >= 8,
  //     hasCase: /^(?=.*[a-z])(?=.*[A-Z])/.test(password),
  //     hasSpecial: /^(?=.*[0-9])(?=.*[!@#$%^&*])/.test(password),
  //   });
  // };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    // if (name === "verifyPassword") {
    //   validatePassword(value);

    //   if (passwordForm.confirmPassword) {
    //     if (passwordForm.confirmPassword !== value) {
    //       setErrors((prev) => ({
    //         ...prev,
    //         confirmPassword: "Passwords do not match",
    //       }));
    //     } else {
    //       setErrors((prev) => ({
    //         ...prev,
    //         confirmPassword: "",
    //       }));
    //     }
    //   }
    // }
  };

  // if (showOTP) {
  //   return <OTPVerification />;
  // }

  return (
    <>
      <div className="mt-10 mb-10 sm:w-1/2 md:w-1/3 ">
        {/* <form className="flex gap-6 items-center" onSubmit={handlePasswordSubmit}> */}
        <h2 className="text-blackShade font-[400] font-geomanistBold text-[20px] leading-[28px]">
          Verify password to change PIN
        </h2>
        <div className="flex flex-col gap-4 mt-4">
          <div>
            <label className="block font-geomanistRegular font-[400] text-[14px] leading-[20px] text-greyish mb-1">
              Verify password
            </label>
            <Input
              type="verifyPassword"
              name="verifyPassword"
              value={passwordForm?.verifyPassword}
              onChange={handlePasswordChange}
              className="w-full text-sm border font-geomanistBold"
              placeholder="Verify password"
            />
            {errors?.verifyPassword && (
              <p className="text-red-500 text-xs mt-1">
                {errors?.verifyPassword}
              </p>
            )}
          </div>

          <div className="flex">
            <button
              type="submit"
              className="bg-blueish text-white px-4 py-2 rounded font-geomanistBold text-sm"
            >
              Proceed to Change PIN
            </button>
          </div>
        </div>
        {/* </form> */}
      </div>
    </>
  );
}

export default ChangePassword;
